module.exports = __webpack_public_path__ + "img/img_product_02@2x.b5edef65.png";